/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_RemoveInputs */

const en_admin_settings_custom_remove = /** @type {(inputs: Admin_Settings_Custom_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const zh_admin_settings_custom_remove = /** @type {(inputs: Admin_Settings_Custom_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Admin_Settings_Custom_RemoveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_remove = /** @type {((inputs?: Admin_Settings_Custom_RemoveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_RemoveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_custom_remove(inputs)
	return zh_admin_settings_custom_remove(inputs)
});
export { admin_settings_custom_remove as "admin.settings.custom.remove" }